export default __webpack_public_path__ + "media/images/flags/wa-19acd8d7c93cab819676bb4ff95c5a2a.png";